import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FrontdeskService } from '../../services/frontdesk/frontdesk.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';

@Component({
  selector: 'app-frontdesk-guest-history',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './frontdesk-guest-history.component.html',
  styleUrl: './frontdesk-guest-history.component.scss',
})
export class FrontdeskGuestHistoryComponent {
  aadhaar = new FormControl('');

  buckets: any = null;
  hasSearched: boolean = false;
  isLoading: boolean = false;

  // matches the buckets the backend returns
  bucketDefs = [
    { key: 'availed', label: 'Availed' },
    { key: 'upcomingConfirmed', label: 'Upcoming confirmed' },
    { key: 'upcomingPending', label: 'Upcoming pending' },
    { key: 'pastPending', label: 'Past pending' },
    { key: 'pastCancelled', label: 'Past cancelled' },
    { key: 'upcomingCancelled', label: 'Upcoming cancelled' },
    { key: 'noShow', label: 'No show' },
  ];

  constructor(
    private frontdeskService: FrontdeskService,
    private toastService: ToastService
  ) {}

  rows(key: string): any[] {
    return (this.buckets && this.buckets[key]) || [];
  }

  get hasAny(): boolean {
    return this.bucketDefs.some((b) => this.rows(b.key).length > 0);
  }

  search(): void {
    const aadhaar = (this.aadhaar.value || '').trim();
    if (!aadhaar) {
      this.toastService.error('Enter an Aadhaar number.');
      return;
    }
    this.isLoading = true;
    this.frontdeskService.getGuestHistory(aadhaar).subscribe({
      next: (res: any) => {
        this.buckets = res?.data || null;
        this.hasSearched = true;
        this.isLoading = false;
      },
      error: (err) => {
        this.buckets = null;
        this.hasSearched = true;
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load guest history.');
      },
    });
  }
}
